<template>
  <div class="intractable-disease-select-dailog dialog col-block width-full">
    <div class="intractable-disease-select-title-container row-block">
      <div class="intractable-disease-select-title-icon-block row-block" :class="{ disabled: param.selectedDatas.length === intractableDiseaseOptions.length }" @click="e => selecteds = (selecteds.length === intractableDiseaseDatas.length ? [] : intractableDiseaseDatas)">
        <img
          class="intractable-disease-select-title-icon"
          :src="(param.selectedDatas.length !== intractableDiseaseOptions.length) ? selecteds.length ? (selecteds.length === intractableDiseaseDatas.length) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg') : require('../../assets/images/checkbox-true.svg')"
        >
      </div>
      <div :style="{ width: '10px' }"></div>
      <div class="intractable-disease-select-title">{{ $t('DIALOG.intractableDiseaseSelect.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="intractable-disease-select-item-field row-block flex-start flex-wrap" :style="{ flex: 1, height: 0 }">
      <div class="intractable-disease-select-item-container col-block width-full" :class="{ disabled: selectedDataValueMap[option.value] }" v-for="(option, oindex) in intractableDiseaseOptions" :key="oindex">
        <div class="intractable-disease-select-item-mask"></div>
        <div class="intractable-disease-select-item-block row-block" @click="e => selecteds = (selecteds.some(selected => selected.value === option.value) ? selecteds.filter(selected => selected.value !== option.value) : selecteds.concat([option]))">
          <img
            class="intractable-disease-select-item-icon"
            :src="(selecteds.some(selected => selected.value === option.value) || selectedDataValueMap[option.value]) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')"
          >
          <div class="intractable-disease-select-item-title ellipsis" :title="$t(option.title)" :style="{ flex: 1 }">{{ $t(option.title) }}</div>
        </div>
      </div>
    </div>
    <div :style="{ height: '25px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => $emit('changeModal', {}, selecteds)">
        <span>{{ $t('COMMON.button.___create') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { intractableDiseaseOptions } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selecteds: []
    }
  },
  computed: {
    intractableDiseaseDatas () {
      return intractableDiseaseOptions.filter(option => !this.selectedDataValueMap[option.value])
    },
    // param
    selectedDataValueMap () {
      return this.param.selectedDatas.reduce((map, data) => ({ ...map, [data.value]: data }), {})
    },
    // global
    intractableDiseaseOptions () { return intractableDiseaseOptions.filter(option => option.type === 'D006-4') }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/intractableDiseaseSelect.vue